import io from 'socket.io-client';
import moment from 'moment';

import excel from 'exceljs';
import fileSaver from 'file-saverjs';

const randomElement = (arr = []) => {
  return arr[Math.floor(Math.random() * arr.length)];
};
const ssoData = () => {
  let env = 'dev';
  let json = {};
  if (env === 'production') {
    json = { sso_url: 'https://sso.ksd.or.kr:8443', client_id: 'DWS', client_secret: 'YDuE_T6f-IKBrBGvg5CBaE3X0MN4xKOnorj5b2XmvgQF7gS3KKQTWhXm7L47ERcqdW8BODh_E10PGTEm8KIigw' };
  } else if (env === 'prev_production') {
    json = { sso_url: 'https://didc-sso.ksd.or.kr:8443', client_id: 'DWS', client_secret: 'eMw8rZvJS5xpvC6g8EZBhPwIXtyNLGhe_NGut0Hl_nbk0BeSZ3_r0EXJukOsLfEukIpEV9E5jj97LVg4QZbKqw' };
  } else {
    // 개발
    json = { sso_url: 'https://ssodev.ksd.or.kr:4443', client_id: 'Conf', client_secret: 'suJzdda7yrvq3zcOqwRAE__BNdZA3do_cOmyOvhMYwojSMi9DbOH9klnJ91YdtuGKmdPYyZyXJP5DCPtSfR2sA' };
  }
  return json;
};
const toggleFullScreen = () => {
  let doc = window.document;
  let docEl = doc.documentElement;

  let requestFullScreen =
    docEl.requestFullscreen ||
    docEl.mozRequestFullScreen ||
    docEl.webkitRequestFullScreen ||
    docEl.msRequestFullscreen;
  let cancelFullScreen =
    doc.exitFullscreen ||
    doc.mozCancelFullScreen ||
    doc.webkitExitFullscreen ||
    doc.msExitFullscreen;

  if (
    !doc.fullscreenElement &&
    !doc.mozFullScreenElement &&
    !doc.webkitFullscreenElement &&
    !doc.msFullscreenElement
  ) {
    requestFullScreen.call(docEl);
  } else {
    cancelFullScreen.call(doc);
  }
};

const ssoLoginCheck = async (p_sid, redirect_uri, env) => {  
  let result = {};
  if (env === 'production') {
    result = { sso_url: 'https://sso.ksd.or.kr:8443', client_id: 'DWS', client_secret: 'YDuE_T6f-IKBrBGvg5CBaE3X0MN4xKOnorj5b2XmvgQF7gS3KKQTWhXm7L47ERcqdW8BODh_E10PGTEm8KIigw' };
  } else if (env === 'prev_production') {
    result = { sso_url: 'https://didc-sso.ksd.or.kr:8443', client_id: 'DWS', client_secret: 'eMw8rZvJS5xpvC6g8EZBhPwIXtyNLGhe_NGut0Hl_nbk0BeSZ3_r0EXJukOsLfEukIpEV9E5jj97LVg4QZbKqw' };
  } else {
    // 개발
    result = { sso_url: 'https://ssodev.ksd.or.kr:4443', client_id: 'Conf', client_secret: 'suJzdda7yrvq3zcOqwRAE__BNdZA3do_cOmyOvhMYwojSMi9DbOH9klnJ91YdtuGKmdPYyZyXJP5DCPtSfR2sA' };
  }
  const sso_url = `${result.sso_url}/sso/auth`;
  
  // Backend에서 가져오도록 수정 (개발서버, 운영서버 동일 코드 가져가기 위함.)
  // const redirect_uri = `http://localhost:8080/ssoSuccess`;
  
  const id_token = sessionStorage.getItem('PARAM_ID_TOKEN') || '';
  const status = Date.now().toString();

  if (id_token) {
    window.location.href = '/main.aspx';
  }

  const consts = {
    response_type: 'code',
    client_id: result.client_id,
    state: Date.now().toString(),
    p_sid: p_sid,
    redirect_uri: redirect_uri,
  };

  const queryParams = new URLSearchParams(consts);

  const redirectUrl = `${sso_url}?${queryParams.toString()}`;
  console.log(`redirectUrl`, redirectUrl);
  window.location.href = redirectUrl;
};

const ssoLoginResult =  (authCode, state, userIp) => {
  let getTokenResult = getTokenByCode(authCode, userIp);
  console.log(`getTokenResult`, getTokenResult);

  return;
};

const getTokenByCode = async (code, userIp, env) => {
  let result = {};
  if (env === 'production') {
    result = { sso_url: 'https://sso.ksd.or.kr:8443', client_id: 'DWS', client_secret: 'YDuE_T6f-IKBrBGvg5CBaE3X0MN4xKOnorj5b2XmvgQF7gS3KKQTWhXm7L47ERcqdW8BODh_E10PGTEm8KIigw' };
  } else if (env === 'prev_production') {
    result = { sso_url: 'https://didc-sso.ksd.or.kr:8443', client_id: 'DWS', client_secret: 'eMw8rZvJS5xpvC6g8EZBhPwIXtyNLGhe_NGut0Hl_nbk0BeSZ3_r0EXJukOsLfEukIpEV9E5jj97LVg4QZbKqw' };
  } else {
    // 개발
    result = { sso_url: 'https://ssodev.ksd.or.kr:4443', client_id: 'Conf', client_secret: 'suJzdda7yrvq3zcOqwRAE__BNdZA3do_cOmyOvhMYwojSMi9DbOH9klnJ91YdtuGKmdPYyZyXJP5DCPtSfR2sA' };
  }

  const client_id = result.client_id;
  const client_secret = result.client_secret;
  let parameters = '';

  parameters += 'response_type' + '=' + 'id_token'+ '&';
  parameters += 'code' +'='+ code +'&';
  parameters += 'client_id' +'='+ client_id +'&';
  parameters += 'client_secret' +'='+client_secret+'&';
  parameters += 'iscltapi'+'='+'Y'+'&';
  parameters += 'w_user_inf' +'='+'Y'+'&';
  parameters += 'remote_ip'+'='+ userIp +'&';
  parameters += 'tgentme'+'='+getUnixTime();


  // let result = post(sso_url+consts.
  //   , parameters);
  // return JSON.parse(parameters);
};

const getUnixTime = () => {
  return Date.now();
};

const getSaehaLayoutOption = (selectedCode, isFixed, layoutFixSeatList) => {
  let saehaLayoutCode = '';
  let layoutCode = '';
  let fixSeatList = '';
  let roomOption = '';

  layoutCode = '12849=0,' + selectedCode.replace('lay', '');
  if (isFixed) {
    fixSeatList += '12888=';
    let seats = layoutFixSeatList
      .filter((fixSeat) => fixSeat.seat !== null && fixSeat.seat.key)
      .map((fixSeat) => {
        return (
          '0,' +
          (fixSeat.id - 1) + // 고정 위치
          ',0,' +
          fixSeat.seat.key + // 고정자리 표시명
          ',' +
          fixSeat.seat.name // 고정자리 Key
        );
      });
    fixSeatList += seats.join('|');
    roomOption = layoutCode + '&' + fixSeatList;
  } else {
    roomOption = layoutCode;
  }

  return roomOption;
};
const generateRandomString = (num) => {
  let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  let result = '';
  const charactersLength = characters.length;
  for (let i = 0; i < num; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
};
const getURLParameter = (sParam) => {
  let sPageURL = window.location.search.substring(1);
  let sURLVariables = sPageURL.split('&');
  for (let i = 0; i < sURLVariables.length; i++) {
    let sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] === sParam) {
      return sParameterName[1];
    }
  }
};
const isEmpty = (str) => {
  if (
    typeof str === 'undefined' ||
    str == null ||
    str === '' ||
    str === 'undefined'
  )
    return true;
  else return false;
};

const getSocket = () => {
  return io('http://localhost:3000');
};

const sort = (arr, key) => {
  return arr.sort((a, b) => {
    return key === undefined ? a - b : a[key] - b[key];
  });
};

const sortString = (arr, key) => {
  return arr.sort((x, y) => {
    let textA = key === undefined ? x : x[key]; // x.title.toUpperCase();
    let textB = key === undefined ? y : y[key]; //  y.title.toUpperCase();
    return textA < textB ? -1 : textA > textB ? 1 : 0;
  });
};

const validationRequired = (value) => !!value || 'Required.';

const validationIpAddress = (value) => {
  const pattern =
    /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/;
  return pattern.test(value) || 'Invalid IP Address.';
};

const validationNumber = (value) => {
  const pattern = /^(\d{2,3})(\d{3,4})(\d{4})$/;
  return pattern.test(value) || false;
};

const validationEmail = (value) => {
  const pattern =
    /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return pattern.test(value) || 'Invalid Email Format.';
};

const isPlainObject = (input) => {
  return input && !Array.isArray(input) && typeof input === 'object';
};

const formatDate = (date) => {
  let d = new Date(date);
  let month = String(d.getMonth() + 1);
  let day = String(d.getDate());
  let year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;
  return [year, month, day].join('-');
};
const ckAccesskey = (meetingKey, meetingPw) => {
  let key = meetingKey + (meetingPw + 7777) * 2;
  return key;
};
const formatTime = (date) => {
  let d = new Date(date);
  let hours = d.getHours();
  let minutes = d.getMinutes();

  hours = hours < 10 ? '0' + hours : hours;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  return hours + ':' + minutes;
};

const formatDtime = (date) => {
  let d = new Date(date);
  let month = String(d.getMonth() + 1);
  let day = String(d.getDate());
  let year = d.getFullYear();
  let hours = d.getHours();
  let minutes = d.getMinutes();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;
  hours = hours < 10 ? '0' + hours : hours;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  return [year, month, day].join('-') + ' ' + hours + ':' + minutes;
};

const formatDtimeSec = (date) => {
  let d = new Date(date);
  let month = String(d.getMonth() + 1);
  let day = String(d.getDate());
  let year = d.getFullYear();
  let hours = d.getHours();
  let minutes = d.getMinutes();
  let seconds = d.getSeconds();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;
  hours = hours < 10 ? '0' + hours : hours;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  seconds = seconds < 10 ? '0' + seconds : seconds;
  return (
    [year, month, day].join('-') + ' ' + hours + ':' + minutes + ':' + seconds
  );
};

const snackBarOpen = (text, color, multiLine) => {
  window.getApp.$emit('APP_SNACK_BAR', text, color, multiLine);
};

const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

const numberToFloorText = (val) => {
  return val < 0 ? 'B' + val * -1 : val;
};

const hasSession = (val, isNoLogout) => {
  // const session = await val.$http.get(`/api/auth/sessionInfo`, { params: { token: val.$store.state.token }});
  // if (session.data === null) {
  //   window.getApp.$emit('APP_LOGOUT');
  //   return false;
  // }
  // return true;
  // if (!val.isUserLoggedIn) {
  //   val.$router.replace('/');
  //   return false;
  // }
  // return true;

  let token = val.$cookies.get('token');
  if (token !== null) {
    val.$http.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    return true;
  } else {
    if (isNoLogout === undefined) {
      window.getApp.$emit('APP_LOGOUT');
    }

    return false;
  }
};

const cloneObject = (obj) => {
  let output = {};
  // eslint-disable-next-line guard-for-in
  for (let i in obj) {
    output[i] = obj[i];
  }
  return output;
};

const utcToLocalTime = (utcTime) => {
  // utcTime.getTime() + ((new Date()).getTimezoneOffset() * 60 * 1000)
};

const dateCompare = (startDtime, endDtime) => {
  let start = formatDate(startDtime);
  let end = formatDate(endDtime);

  let date = new Date();
  let now = formatDate(date.toUTCString());

  return now === start || now === end ? true : false;
};

const nearestFutureMinutes = (interval, someMoment) => {
  const roundedMinutes = Math.ceil(someMoment.minute() / interval) * interval;
  return someMoment.clone().minute(roundedMinutes).second(0);
};

const statusColors = {
  s: '#ACD373',
  r: '#3CB878',
  e: '#B7B7B7',
  q: 'blue',
  c: 'pink',
};

const typeColors = {
  video: 'pink',
  lecture: 'primary',
  room: 'green',
};

const getColorByStatus = (status, flag) => {
  if (flag) {
    return flag === 'd'
      ? status === 'q'
        ? statusColors['c'] // 요청에 대한 반려
        : statusColors['e'] // 요청했다가 내가 취소
      : status === 'q'
      ? statusColors['q'] // 요청중
      : statusColors['s']; // 승인
  } else {
    if (status === null) {
      return statusColors['e'];
    }
    return statusColors[status];
  }
};

const getColorByExternalUsrStatus = (status) => {
  if (status === null) {
    return statusColors['e'];
  }
  if (status === 'a') {
    return statusColors['s'];
  }
  return statusColors[status];
};

const getColorByRoomStatus = (status, flag) => {
  if (flag) {
    return flag === 'd'
      ? status === 'waiting'
        ? statusColors['e'] // 요청했다가 내가 취소
        : statusColors['c'] // 요청에 대한 반려
      : status === 'waiting'
      ? statusColors['q'] // 요청중
      : status === 'active'
      ? statusColors['s'] // 승인
      : statusColors['c']; // 반려
  } else {
    if (status === null) {
      return statusColors['e'];
    }
    return statusColors[status];
  }
};
const isDuplicate = (list) => {
  // 중복된 데이터 카운팅
  let resultArray = []; // 카운팅해서 반환할 결과값 배열
  let duplicateCount = [];
  list.map((item) => {
    //for each item in arrayOfObjects check if the object exists in the resulting array
    if (
      resultArray.find((object) => {
        if (object.email === item.email && object.email !== undefined) {
          //if the object exists iterate times
          object.cnt++;
          duplicateCount.push(object);
          return true;
          //if it does not return false
        } else {
          return false;
        }
      })
    ) {
    } else {
      //if the object does not exists push it to the resulting array and set the times count to 1
      item.cnt = 1;
      resultArray.push(item);
    }
  });

  return duplicateCount;
};

const getColorByMeetingType = (type) => {
  if (type === null) {
    return statusColors['e'];
  }
  return typeColors[type];
};

const replaceAll = (str, searchStr, replaceStr) => {
  return str.split(searchStr).join(replaceStr);
};

const getNodeByValue = (itemName, value, node) => {
  let reduce = [].reduce;
  function runner(result, node) {
    if (result || !node) return result;
    return (
      (node[itemName] === value && node) ||
      runner(null, node.children) ||
      reduce.call(Object(node), runner, result)
    );
  }
  return runner(null, node);
};

const getNodeByValueLike = (itemName, value, node) => {
  let reduce = [].reduce;
  function runner(result, node) {
    if (result || !node) return result;
    return (
      (node[itemName] &&
        node[itemName].toUpperCase().includes(value) &&
        node) ||
      runner(null, node.children) ||
      reduce.call(Object(node), runner, result)
    );
  }
  return runner(null, node);
};

/**
 * @params
 * m => '2019-10-10'
 */
const getWeekOfMonth = (m) => {
  return m.week() - moment(m).startOf('month').week() + 1;
};

/**
 * @params
 *
 */
const exportExcel = (sheetName, columns, items, isAutoFilter, fileName) => {
  // create workbook & add worksheet
  let workbook = new excel.Workbook();
  let worksheet = workbook.addWorksheet(sheetName);

  // hearder Setting
  worksheet.columns = columns;

  // Insert Rows
  items.forEach((data) => {
    worksheet.addRow(data);
  });

  if (isAutoFilter) {
    // Setting Auto Filter
    worksheet.autoFilter = {
      from: {
        row: 1,
        column: 1,
      },
      to: {
        row: 1,
        column: worksheet.columns.length,
      },
    };
  }

  // File download
  workbook.xlsx.writeBuffer().then(function (buffer) {
    fileSaver(
      new Blob([buffer], { type: 'application/octet-stream' }),
      fileName
    );
  });
};

const arrayIntersection = (arr1, arr2, sourceKey, targetKey, condition) => {
  let retArr = arr1.filter((element) => {
    for (let i = 0; i < arr2.length; i++) {
      if (element[sourceKey] === arr2[i][targetKey]) {
        if (condition) {
          if (arr2[i][condition] === undefined) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      }
    }
    return false;
  });
  return retArr;
};

const secondsToTimeString = (duration) => {
  let hour =
    (duration / (60 * 60) < 10 ? '0' : '') + Math.trunc(duration / (60 * 60));
  let minute = ('0' + Math.trunc(duration / 60)).slice(-2);
  let second = ('0' + Math.trunc(duration % 60)).slice(-2);
  return [hour, minute, second].join(':');
};

const calendarColors = {
  video: '#015276', // '#657F7C',
  room: '#04BBEC', // '#7E8BA6'
};

const getRandomNumber = (start, end) => {
  return Math.floor(Math.random() * (end - start + 1) + start);
};

const getTwoDateRangeMonths = (startDate, endDate) => {
  let result = [];

  if (endDate.isBefore(startDate)) {
    return false;
  }

  while (startDate.isBefore(endDate)) {
    result.push(startDate.format('YYYY-MM'));
    startDate.add(1, 'month');
  }

  return result;
};

const deviceMultipleSort = (array) => {
  return array.sort((a, b) => {
    let groupA = a.buildingId.groupId.name;
    let groupB = b.buildingId.groupId.name;
    let buildingA = a.buildingId.name;
    let buildingB = b.buildingId.name;

    if (groupA < groupB) return 1;
    if (groupA > groupB) return -1;
    if (buildingA < buildingB) return 1;
    if (buildingA > buildingB) return -1;
    return 0;
  });
};

const roomManageCheck = (room, email) => {
  if (
    room.reserveManagerEmail !== null &&
    room.reserveManagerEmail !== undefined
  ) {
    if (room.reserveManagerEmail.email !== email) {
      return true;
    }
    // let index = room.reserveManagerEmail.findIndex(x => x === email || x.email === email);
    // if (index < 0) {
    //   return true;
    // }
    return false;
  }
  return undefined;
};

const roomDepartmentCheck = (room, orgUnitId, workOrgUnitId, email) => {
  if (
    room.reserveDepartment !== null &&
    room.reserveDepartment !== undefined &&
    room.reserveDepartment.length > 0
  ) {
    let onlyOrg = room.reserveDepartment.filter(
      (dept) => dept.deptName !== undefined
    );

    let findOrgAuth = onlyOrg.filter(
      (dept) => dept.orgUnitId === orgUnitId || dept.orgUnitId === workOrgUnitId
    );
    let findUserAuth = room.reserveDepartment.filter(
      (dept) => dept.email === email
    );
    let findSubOrgAuth =
      room.reserveSubDepartments !== undefined &&
      room.reserveSubDepartments !== null
        ? room.reserveSubDepartments.filter(
            (dept) => dept === orgUnitId || dept === workOrgUnitId
          )
        : undefined;
    if (findSubOrgAuth !== undefined) {
      if (
        findOrgAuth.length < 1 &&
        findUserAuth.length < 1 &&
        findSubOrgAuth.length < 1
      ) {
        return true;
      }
    } else {
      if (findOrgAuth.length < 1 && findUserAuth.length < 1) {
        return true;
      }
    }
    return false;
  }
  return undefined;
};

const logOut = async (val) => {
  try {
    await val.$http.post(`/api/auth/logout`);
    return true;
  } catch (err) {
    console.log(err);
  }
};

const getDepth = (tree) => {
  let depth = 0;
  if (tree.children) {
    tree.children.forEach(function (d) {
      let tmpDepth = getDepth(d);
      if (tmpDepth > depth) {
        depth = tmpDepth;
      }
    });
  }
  return 1 + depth;
};

const numberToMoney = (number) => {
  if (number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  } else {
    return 0;
  }
};

const getParam = (sParam) => {
  let sPageURL = window.location.search.substring(1);
  let sURLVariables = sPageURL.split('&');
  for (let i = 0; i < sURLVariables.length; i++) {
    let sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] === sParam) {
      return sParameterName[1];
    }
  }
};
const isDevice = () => {
  let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent); // 안드로이드 아이폰을 검사해 체크
  return isMobile;
};

const getOS = () => {
  try {
    let OsVersion = navigator.userAgent;
    OsVersion = OsVersion.toUpperCase();
    console.log(`OsVersion : `, OsVersion);
    if (OsVersion.indexOf('NT 5.1') !== -1) {
      return 'windows XP';
    } else if (OsVersion.indexOf('NT 6.0') !== -1) {
      return 'windows vista';
    } else if (OsVersion.indexOf('NT 6.1') !== -1) {
      return 'windows 7';
    } else if (OsVersion.indexOf('NT 6.2') !== -1) {
      return 'windows 8';
    } else if (OsVersion.indexOf('NT 6.3') !== -1) {
      return 'windows 8.1';
    } else if (OsVersion.indexOf('NT 10.0') !== -1) {
      return 'windows 10';
    } else if (OsVersion.indexOf('MAC') !== -1) {
      return 'MAC';
    } else if (OsVersion.indexOf('SYMBIAN') !== -1) {
      return 'Symbian';
    } else if (OsVersion.indexOf('UBUNTU') !== -1) {
      if (OsVersion.indexOf('86_64') !== -1) {
        return 'UBUNTU64';
      } else {
        return 'UBUNTU32';
      }
    } else if (OsVersion.indexOf('FEDORA') !== -1) {
      if (OsVersion.indexOf('86_64') !== -1) {
        return 'FEDORA64';
      } else {
        return 'FEDORA32';
      }
    } else if (OsVersion.indexOf('LINUX') !== -1) {
      if (OsVersion.indexOf('86_64') !== -1) {
        return 'LINUX64';
      } else {
        return 'LINUX32';
      }
    }
  } catch (ex) {
    return 'Unknown';
  }
};

export default {
  getSaehaLayoutOption,
  randomElement,
  toggleFullScreen,
  getSocket,
  sort,
  sortString,
  validationRequired,
  validationIpAddress,
  validationNumber,
  validationEmail,
  isPlainObject,
  formatDate,
  formatTime,
  getParam,
  formatDtime,
  formatDtimeSec,
  snackBarOpen,
  capitalizeFirstLetter,
  numberToFloorText,
  hasSession,
  cloneObject,
  isDuplicate,
  utcToLocalTime,
  dateCompare,
  nearestFutureMinutes,
  getColorByStatus,
  getColorByRoomStatus,
  replaceAll,
  getNodeByValue,
  getNodeByValueLike,
  getWeekOfMonth,
  exportExcel,
  arrayIntersection,
  secondsToTimeString,
  calendarColors,
  getRandomNumber,
  getTwoDateRangeMonths,
  deviceMultipleSort,
  roomManageCheck,
  roomDepartmentCheck,
  getDepth,
  getColorByMeetingType,
  getColorByExternalUsrStatus,
  numberToMoney,
  logOut,
  getOS,
  isDevice,
  isEmpty,
  getURLParameter,
  ckAccesskey,
  ssoLoginCheck,
  ssoLoginResult,
  getTokenByCode,
  getUnixTime,
  ssoData,
};



// WEBPACK FOOTER //
// ./src/util/index.js